const DEFAULT_COOKIE_DOMAIN = '.wanderu.com';

interface CookieDomainLogger {
    warn: (method: string, message: string, context: Record<string, unknown>) => unknown;
}

interface ResolveCookieDomainArgs {
    caller: string;
    configKey: string;
    configuredDomain?: string;
    context?: Record<string, unknown>;
    logger: CookieDomainLogger;
}

/**
 * Picks the domain a first-party identity cookie is scoped to. Non-prod is
 * served from ui.<env>.wanderu.dev, where a .wanderu.com cookie is rejected
 * outright and the id churns on every page load, so each environment names
 * its own domain in config. The fallback is right for production but a
 * missing key must be visible, so it is logged rather than silent.
 */
function resolveCookieDomain({
    caller,
    configKey,
    configuredDomain,
    context = {},
    logger,
}: ResolveCookieDomainArgs): string {
    if (configuredDomain) {
        return configuredDomain;
    }

    logger.warn(
        caller,
        `${configKey} is not configured; falling back to ${DEFAULT_COOKIE_DOMAIN}`,
        { ...context, fallbackDomain: DEFAULT_COOKIE_DOMAIN },
    );

    return DEFAULT_COOKIE_DOMAIN;
}

export { DEFAULT_COOKIE_DOMAIN, resolveCookieDomain };
